import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';
import './About.css';

const About = () => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage];

  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">{t.about.title}</h2>
        <div className="about-content">
          <div className="about-text">
            <p className="about-intro">
              {t.about.intro}
            </p>
            <p>
              {t.about.experience}
            </p>
            <p>
              {t.about.development}
            </p>
            <div className="about-stats">
              <div className="stat">
                <h3>10+</h3>
                <p>{t.about.stats.years}</p>
              </div>
              <div className="stat">
                <h3>1000+</h3>
                <p>{t.about.stats.hours}</p>
              </div>
              <div className="stat">
                <h3>300+</h3>
                <p>{t.about.stats.therapy}</p>
              </div>
            </div>
          </div>
          <div className="about-image">
            <div className="about-photo-container">
              <img 
                src="/images/ludmila-photo-2.jpg" 
                alt={`${t.hero.title} - професійне фото`}
                className="about-photo"
              />
            </div>
            <div className="about-card">
              <div className="card-content">
                <h3>{t.about.formats.title}</h3>
                <ul>
                  <li>{t.about.formats.individual}</li>
                  <li>{t.about.formats.couples}</li>
                  <li>{t.about.formats.online}</li>
                  <li>{t.about.formats.office}</li>
                  <li>{t.about.formats.languages}</li>
                  <li>{t.about.formats.duration}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
